import axios from 'axios';
import type { ReactNode } from 'react';

import { isSignupEmailErrorCode } from '@revelio/iso-utility';

import { ThemeLink } from '../components/theme/theme';

const SALES_EMAIL = 'sales@reveliolabs.com';
const FALLBACK = 'Failed to create user.';
const FIELD_ERROR = 'Please enter a valid work email address';

export function SalesCta() {
  return (
    <>
      , or reach out to{' '}
      <ThemeLink href={`mailto:${SALES_EMAIL}`} style={{ color: 'inherit' }}>
        {SALES_EMAIL}
      </ThemeLink>
      .
    </>
  );
}

// Only 400 bodies are curated for users; anything else gets the fallback.
function apiErrorCode(err: unknown): unknown {
  if (!axios.isAxiosError(err)) return null;
  if (err.response?.status !== 400) return null;

  const data: unknown = err.response.data;
  if (!data || typeof data !== 'object') return null;

  return (data as Record<string, unknown>).code;
}

export function signupEmailFieldError(err: unknown): string | null {
  return isSignupEmailErrorCode(apiErrorCode(err)) ? FIELD_ERROR : null;
}

export function signupErrorMessage(err: unknown): ReactNode {
  return signupEmailFieldError(err) ? null : FALLBACK;
}
